export default "__VITE_ASSET__CFnitkbq__"